<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="上架状态">
          <el-radio-group v-model="form.step" size="mini">
            <el-radio-button :label="1">未上架</el-radio-button>
            <el-radio-button :label="2">上架</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="预约时段" prop="section">
          <el-time-picker
            is-range
            v-model="form.section"
            range-separator="至"
            value-format="HH:mm:ss"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择预约时段"
          ></el-time-picker>
        </el-form-item>
        <el-form-item label="备注" prop="text">
          <el-input
            v-model="form.text"
            type="textarea"
            class="fix-width"
            placeholder="请输入备注"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createSection, updateSection } from '@/api/chess'
export default {
  name: 'ChessSectionEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      form: {
        sectionId: '',
        title: '',
        section: [],
        text: '',
        order: 1,
        step:1
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        section: [{
          required: true, trigger: 'blur', message: '请选择预约时段'
        }]
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    async showEdit(row) {
      if (row) {
        this.title = '修改时段'
        this.form = Object.assign(this.form, row.basic)
        this.form.sectionId = row.sectionId
        this.form.title = row.title
        this.form.section = [row.basic.startTime,row.basic.endTime]
        this.form.step = row.step
      } else {
        this.title = '新增时段'
      }
      this.dialogFormVisible = true
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const sectionId = this.form.sectionId
          const data = Object.assign({}, this.form)
          const startTime = data.section[0]
          const endTime = data.section[1]
          data.startTime = startTime
          data.endTime = endTime
          delete data.section
          this.$baseConfirm(
            `你确定要${sectionId ? '修改' : '新增'}时段吗`,
            null,
            async () => {
              sectionId ? await updateSection(data) : await createSection(data)
              this.$baseMessage(
                `${sectionId ? '修改' : '新增'}时段成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.icon_avatar {
  width: 50px;
  height: 50px;
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.el-icon-circle-plus-outline {
  color: #409eff;
}

.el-icon-remove-outline {
  color: #f56c6c;
  margin-left: 15px;
}
</style>
